export const licenceConstants = {
    LICENCE_LOADING: "licence_loading",
    LICENCE_LOADED: "licence_loaded",
    LICENCE_ERROR: "licence_error",
    LICENCE_EDIT: "licence_edit",
    LICENCE_CREATE: "licence_create",
}